import { render, staticRenderFns } from "./KitchenTypes.vue?vue&type=template&id=7473bcf1&"
import script from "./KitchenTypes.vue?vue&type=script&lang=js&"
export * from "./KitchenTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports